export const FETCH_VEHICLE_BODYTYPES_DATA = "FETCH_VEHICLE_BODYTYPES_DATA";
export const FETCH_VEHICLE_BODYTYPES_SUCCESS = "FETCH_VEHICLE_BODYTYPES_SUCCESS";
export const FETCH_VEHICLE_BODYTYPES_FAILURE = "FETCH_VEHICLE_BODYTYPES_FAILURE";

export const FETCH_VEHICLE_BODYTYPES_EDIT_DATA = "FETCH_VEHICLE_BODYTYPES_EDIT_DATA";
export const FETCH_VEHICLE_BODYTYPES_EDIT_SUCCESS = "FETCH_VEHICLE_BODYTYPES_EDIT_SUCCESS";
export const FETCH_VEHICLE_BODYTYPES_EDIT_FAILURE = "FETCH_VEHICLE_BODYTYPES_EDIT_FAILURE";